import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { bindActionCreators } from "redux";
import { updateDestAction } from "../../../../modules/destinations/action";
import DestinationForm from "../DestinationForm";

class EditExternalDest extends Component {
  state = {
    successMessage: "",
    errorMessage: {}
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.destUpdated && nextProps.destUpdated.status === 200) {
      this.setState({ successMessage: true });
    }
  }

  handleSubmit = destInfo => {
    destInfo.id = this.props.selectedDest.id;
    this.props.updateDestAction(destInfo);
  };

  render() {
    const { successMessage } = this.state;
    const { selectedDest } = this.props;
    if (successMessage) {
      return <Redirect to="/farmsetup/destinations/external" />;
    }
    return (
      <DestinationForm
        editMode={true}
        buttonLabel="Update"
        formLabel="Edit destination"
        destInfo={selectedDest}
        handleSubmit={this.handleSubmit}
        MainFarmId={this.props.MainFarmId}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    selectedDest: state.destReducer.selectedDest,
    destUpdated: state.destReducer.destUpdated,
    MainFarmId: state.FarmManagementReducer.MainFarmId
  };
}

const mapDispatchToProps = dispatch =>
  bindActionCreators({ updateDestAction }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EditExternalDest);



// WEBPACK FOOTER //
// ./src/components/private/Destinations/ExternalDest/EditExternalDest.js